<template>
  <panel class="mgb10">
    <el-form ref="scanForm" :model="scanObj">
      <el-form-item
        :prop="'workerSerialNo'"
        :rules="[
          {
            required: true,
            message: $t('rules.required', [$t('menu.workers')]),
            trigger: 'blur',
          },
        ]"
      >
        <el-input
          v-model="scanObj.workerSerialNo"
          placeholder="工号"
          @keypress.enter.native="workerSnEnterKeyUp('woSnsStart')"
        ></el-input>
      </el-form-item>

      <el-form-item
        :prop="'phaseId'"
        :rules="[
          {
            required: true,
            message: $t('rules.required', [$t('menu.phases')]),
            trigger: 'blur',
          },
        ]"
      >
        <el-select
          v-model="scanObj.phaseId"
          placeholder="选择工序"
          filterable
          class="mb10"
          @change="getManufactures"
        >
          <el-option
            v-for="phase in workerPhases"
            :key="phase.phaseId"
            :label="phase.phaseName"
            :value="phase.phaseId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :prop="'_workOrderSerialNo'">
        <el-input
          v-model="scanObj._workOrderSerialNo"
          placeholder="工单号"
          @keypress.enter.native="workOrderSerialNoEnterKeyUp()"
        ></el-input>
      </el-form-item>
      <div v-if="unFinishedManufacturesFilter.length == 0">
        {{ $t("text.noData") }}
      </div>
      <div
        v-else
        v-for="(m, index) of unFinishedManufacturesFilter"
        :key="index"
        class="mgb10"
        style="
          height: 36px;
          line-height: 36px;
          text-align: middle;
          border: 1px solid rgb(220, 223, 230);
          border-radius: 3px;
          background: #ffffff;
        "
      >
        <div
          class="float-left"
          style="width: 200px; line-height: 36px; padding-left: 10px"
        >
          {{ m.workOrderSn }}
        </div>
        <div
          class="float-right"
          style="
            height: 36px;
            line-height: 36px;
            padding: 0 10px;
            background: #67c23a;
            color: #fff;
          "
          :loading="endPhaseDoing"
          @click="endManufacture(m)"
        >
          结束
        </div>
      </div>
    </el-form>
  </panel>
</template>

<script>
import { page } from "@/utils/mixins.js";

import Worker from "@/api/worker.js";
import WorkOrder from "@/api/workOrder.js";
import Manufacture from "@/api/manufacture.js";
import Util from "@/utils";

export default {
  mixins: [page],
  data() {
    return {
      // 扫描
      scanObj: {
        workerSerialNo: null,
        phaseId: null,
        phaseName: null,
        dispatch: true,
        _workOrderSerialNo: null,
      },
      worker: null,
      workerPhases: [],
      unFinishedManufactures: [],
      unFinishedManufacturesFilter: [],

      scanSubmitDing: false,
      workerExist: false,

      endPhaseDoing: false,
    };
  },
  methods: {
    selectScanObjType() {
      const self = this;
      self.clear();
    },
    clear() {
      const self = this;
      self.scanObj.workerSerialNo = null;
      self.scanObj.phaseId = null;
      self.scanObj.phaseName = null;
      self.scanObj._workOrderSerialNo = null;

      self.worker = null;
      self.workerPhases = [];
      self.unFinishedManufactures = [];
      self.unFinishedManufacturesFilter = [];
    },
    workerSnEnterKeyUp(type) {
      const self = this;
      self.workerExist = true;

      self.scanObj.phaseId = null;
      self.scanObj.phaseName = null;
      self.worker = null;
      self.unFinishedManufactures = [];
      self.unFinishedManufacturesFilter = [];
      if (self.scanObj.workerSerialNo == null) {
        self.$message({ message: "请先扫描工号", type: "warning" });
        return;
      }
      Worker.findBySerialNo({ serialNo: self.scanObj.workerSerialNo }).then(
        function (res) {
          if (res.data.code === 200) {
            self.worker = res.data.entity;
            self.workerPhases = res.data.entity.workerPhases;
            if (self.workerPhases.length !== 0) {
              self.scanObj.phaseId = self.workerPhases[0].phaseId;
              self.scanObj.phaseName = self.workerPhases[0].phaseName;
            }
            self.getManufactures();
          } else {
            self.workerExist = false;
            self.$message({ message: "该工人不存在", type: "warning" });
          }
        }
      );
    },

    getManufactures() {
      const self = this;
      self.unFinishedManufactures = [];
      self.unFinishedManufacturesFilter = [];
      if (self.worker != null && self.scanObj.phaseId != null) {
        const obj = {
          workerId: self.worker.id,
          phaseId: self.scanObj.phaseId,
        };
        Manufacture.unFinished(obj).then(function (res) {
          self.unFinishedManufactures = res.data;
          self.unFinishedManufacturesFilter = self.unFinishedManufactures;
        });
      } else {
        self.$message({
          message: "请扫描有效的工人或者选择有效工序",
          type: "warning",
        });
      }
    },

    workOrderSerialNoEnterKeyUp() {
      const self = this;
      if (
        self.scanObj._workOrderSerialNo !== null &&
        self.unFinishedManufactures.length !== 0
      ) {
        if (
          self.scanObj._workOrderSerialNo !== null &&
          self.scanObj._workOrderSerialNo !== ""
        ) {
          self.unFinishedManufacturesFilter =
            self.unFinishedManufactures.filter(
              (m) => m.workOrderSn === self.scanObj._workOrderSerialNo
            );
        } else {
          self.unFinishedManufacturesFilter = self.unFinishedManufactures;
        }
      }
    },

    endManufacture(m) {
      const self = this;
      self.endPhaseDoing = true;
      Manufacture.batchFinish([m.id]).then(function (res) {
        self.endPhaseDoing = false;
        if (res.status === 200) {
          self.getManufactures();
          self.workOrderSerialNoEnterKeyUp();
          self.scanObj._workOrderSerialNo == null;
          self.$message({ message: "结束成功", type: "success" });
        } else {
          self.sysError();
        }
      });
    },
  },
};
</script>

<style scoped>
</style>